import { Navigate, useLocation } from 'react-router-dom';
import { authService } from '../services/AuthService';
import { disconnectWebSocket } from '../config/WebsocketService';
import { useState, useEffect } from 'react';

export default function PrivateRoute({ children }) {
  const location = useLocation();
  const [isChecking, setIsChecking] = useState(true);
  const [isAuth, setIsAuth] = useState(false);

  useEffect(() => {
    setIsChecking(true);
    authService.validateSession().then(session => {
      setIsAuth(session && session.authenticated);
      setIsChecking(false);
    }).catch(() => {
      setIsAuth(false);
      setIsChecking(false);
    });
  }, [location.pathname]); // Re-valida cada vez que cambia la ruta

  if (isChecking) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <div>Verificando sesión...</div>
      </div>
    );
  }

  if (!isAuth) {
    disconnectWebSocket({ allowReconnect: false });
    authService.clearAuthData();
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
}
